// Third Party Imports
import React from 'react';
import PropTypes from 'prop-types';

// HA Artifactory modal
import Modal from '@homeaway/react-modal';
import {ButtonPrimary} from '@homeaway/react-buttons';

// Relative Imports
import './SameSoftwareModal.less';

class SameSoftwareModal extends React.Component {
    render() {
        let {
            translations,
            isOpen,
            onClose
        } = this.props;
        return (
            <div className="same-software-modal">
                <Modal
                    id="sameSoftwareModal"
                    isOpen={isOpen}
                    onClose={onClose}
                    closeButton={false}
                    footer={
                        <div className="okay-btn-holder">
                            <ButtonPrimary
                                label={translations['ipmob.same_software_modal.button_text']}
                                id="sameSoftwareOkayBtn"
                                className="okay-btn"
                                onClick={onClose}
                            />
                        </div>
                    }
                >
                    <div className="same-software-modal-head">
                        {translations['ipmob.same_software_modal.header']}
                    </div>
                    <div className="same-software-modal-body">
                        <p>{translations['ipmob.same_software_modal.body']}</p>
                        <p>{translations['ipmob.same_software_modal.body_2']}</p>
                    </div>
                </Modal>
            </div>
        );
    }
}

SameSoftwareModal.propTypes = {
    translations: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

SameSoftwareModal.defaultProps = {
    translations: {},
    isOpen: false,
    onClose: () => {}
};

export default SameSoftwareModal;
